import React from "react";
import AggregatedSummaryList from "components/AggregatedSummaryList/AggregatedSummaryList";
import {
  UFL_PROGRAM_TYPE_LIST_COLUMNS,
  UFL_PROGRAM_TYPE_MODAL_COLUMNS,
} from "lookup/ProgramTypeSummaryListColumns";
import { showNotification } from "services/NotificationService";

const uflProgramTypeListConfig = {
  id: "ufl-program-type-list",
  mode: "api-driven",

  cache: { enabled: false },

  header: {
    totalLabel: "Total Unprocessed Faxes",
    title: "Unprocessed Fax List",
    totalCountColumn: "faxCount",
  },

  fetch: {
    url: "/ufl/program-type-list",
    mapResponse: (response) => ({
      rows: response?.data?.unprocessedFaxProgramTypeList || [],
    }),
  },

  notifications: {
    loadError: {
      title: "Unable to load Unprocessed Faxes!",
      message: "SOMETHING WENT WRONG",
    },
  },

  table: {
    getColumns: (handlers) =>
      UFL_PROGRAM_TYPE_LIST_COLUMNS(handlers.onPriorityClick),
    showPagination: false,
    pageSize: 25,
    rowClassName: "clickable-row",
  },

  rowClick: {
    onRowClick: (row, navigate) => {
      if (!row.original.faxCount) {
        showNotification({
          title: "No Faxes Available",
          message: `Fax program type "${row.original.faxProgramTypeName}" has 0 faxes.`,
          position: "tr",
          type: "warning",
        });
        return;
      }

      const query = new URLSearchParams({
        faxProgramCode: row.original.faxProgramTypeCode,
      }).toString();

      navigate(`/unprocessed-fax/fax-list?${query}`, { state: { reset: true } });
    },
  },

  modal: {
    enabled: true,
    title: "Priority Details",
    size: "lg",
    getColumns: () => UFL_PROGRAM_TYPE_MODAL_COLUMNS(),
    getNestedRows: (row) => row.unprocessedFaxPriorities || [],
    emptyMessage: "No priority details available for this program.",
    onModalRowClick: (parentRow, modalRow, navigate) => {
      const query = new URLSearchParams({
        faxProgramCode: parentRow.faxProgramTypeCode,
        faxPriority: modalRow.original.priority,
      }).toString();

      navigate(`/unprocessed-fax/fax-list?${query}`, {
        state: { reset: true, lockPriorityFilter: true },
      });
    },
  },
};

const UnprocessedFaxProgramTypeList = () => (
  <AggregatedSummaryList config={uflProgramTypeListConfig} />
);

export default UnprocessedFaxProgramTypeList;
